import {Component} from '@angular/core';
import {Field} from '../model/field.model';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {StateService} from '../state.service';
import {TruffleFound} from '../model/truffelFound.model';
import {calculateYearlyYield, inferStartYear, YearlyYield} from '../utils/yield.utils';

@Component({
    selector: 'app-field',
    templateUrl: './field.component.html',
    styleUrls: ['./field.component.css'],
    standalone: false
})
export class FieldComponent {
  fields: Observable<Field[]>;

  constructor(private router: Router, private stateService: StateService) {
    this.fields = stateService.getFields();
  }

  editField(field: Field) {
    this.stateService.field = field;
    this.router.navigate( ['editField']);
  }

  deleteField(field: Field) {
    if (field.lines.length > 0) {
      alert('Feld kann nicht gelöscht wenn es Reihen hat.');
    } else {
      this.stateService.deleteField(field);
    }
  }

  getTotalTrees(field: Field) {
    let numOfTrees = 0;
    field.lines.forEach(line => {
      numOfTrees += line.trees.length;
    });
    return numOfTrees;
  }

  getTotalTrufflePerField(field: Field) {
    let totalTruffleFound = 0;
    field.lines.forEach(line => {
      line.trees.forEach(tree => {
        tree.truffleFounds.forEach(found => {
          totalTruffleFound += found.weight;
        });
      });
    });
    return totalTruffleFound;
  }

  getAvgTrufflePertree(field: Field) {
    return this.getTotalTrufflePerField(field) / this.getTotalTrees(field);
  }

  getYearlyYieldForField(field: Field): YearlyYield[] {
    const founds: TruffleFound[] = [];
    field.lines.forEach(line => {
      line.trees.forEach(tree => {
        tree.truffleFounds?.forEach(found => founds.push(found));
      });
    });
    const startYear = inferStartYear(field.createdAt, undefined, founds);
    return calculateYearlyYield(founds, startYear);
  }
}
